import React from 'react'
import { Component, LocaleCode } from '../types/component'
import { getLocalizedText } from '../utils/localization'

interface FooterProps {
  component: Component
  locale: LocaleCode
  storeId: string
  apiUrl: string
  style: React.CSSProperties
}

export function Footer({ component, locale, style }: FooterProps) {
  const config = component.config as any

  const companyName = config.companyName
  const tagline = config.tagline
  const copyright = config.copyright
  const sections = config.sections || []
  const social = config.social || {}

  return (
    <div style={style} className="w-full">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Company Info */}
          <div>
            {companyName && (
              <h3 className="text-xl font-bold mb-2" style={{ color: style.color }}>
                {companyName}
              </h3>
            )}
            {tagline && (
              <p className="text-sm opacity-70 mb-4" style={{ color: style.color }}>
                {tagline}
              </p>
            )}

            {/* Social Links */}
            {Object.keys(social).length > 0 && (
              <div className="flex gap-3">
                {social.twitter && (
                  <a
                    href={social.twitter}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-xl hover:scale-125 transition-transform no-underline"
                    style={{ color: style.color }}
                  >
                    🐦
                  </a>
                )}
                {social.facebook && (
                  <a
                    href={social.facebook}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-xl hover:scale-125 transition-transform no-underline"
                    style={{ color: style.color }}
                  >
                    📘
                  </a>
                )}
                {social.instagram && (
                  <a
                    href={social.instagram}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-xl hover:scale-125 transition-transform no-underline"
                    style={{ color: style.color }}
                  >
                    📷
                  </a>
                )}
                {social.linkedin && (
                  <a
                    href={social.linkedin}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-xl hover:scale-125 transition-transform no-underline"
                    style={{ color: style.color }}
                  >
                    💼
                  </a>
                )}
                {social.github && (
                  <a
                    href={social.github}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-xl hover:scale-125 transition-transform no-underline"
                    style={{ color: style.color }}
                  >
                    🐙
                  </a>
                )}
              </div>
            )}
          </div>

          {/* Link Sections */}
          {sections.map((section: any, index: number) => (
            <div key={index}>
              <h4 className="text-sm font-semibold mb-3 uppercase tracking-wider" style={{ color: style.color }}>
                {section.title}
              </h4>
              <ul className="space-y-2 list-none p-0 m-0">
                {section.links.map((link: any, linkIndex: number) => (
                  <li key={linkIndex}>
                    <a
                      href={link.href}
                      className="text-sm opacity-70 hover:opacity-100 transition-opacity no-underline"
                      style={{ color: style.color }}
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Copyright */}
        {copyright && (
          <div
            className="border-t pt-6"
            style={{ borderColor: style.color ? `${style.color}20` : 'rgba(0,0,0,0.1)' }}
          >
            <p className="text-sm text-center opacity-60" style={{ color: style.color }}>
              {copyright}
            </p>
          </div>
        )}
      </div>
    </div>
  )
}
